<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.no-indent {
  .desc{
    text-indent: 0
  }
}
.wrap-tec .lists li {
  width: 33.3%;
}
@media screen and (max-width: 640px) {
  .wrap-tec .lists li {
    width: 100% !important;
    p {
      margin: 5px auto !important;
    }
  }
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>全转录组测序</h1>-->
<!--          <h2 class="mt10">Whole transcriptome sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>全转录组测序</h1>
      <h2 class="mt10">Whole Transcriptome Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">
        全转录组是指特定组织或细胞在特定状态下转录出的所有转录本的总和，包括mRNA和所有的non-coding RNA。全转录组测序应用RNA-Seq技术，通过构建两种文库（small RNA文库和去rRNA的链特异性文库），对四种RNA（miRNA，lncRNA，mRNA，circRNA）的表达及调控关系进行分析。同时分析miRNA，lncRNA，mRNA，circRNA四种RNA的表达及调控关系；验证已知lncRNA，预测novel lncRNA；鉴定已知circRNA的同时，预测新的circRNA及其靶标。可结合多种RNA信息进行ceRNA整合分析，探究其潜在的调控网络机制已成为解释生物学现象的研究利器。
      </p>
      <en-title title="应用领域" enTitle="Application" />
      <application-icon :iconList="iconList" :lines="2" menuTitle="全转录组测序"/>
      <en-title title="技术参数" enTitle="Specifications" />
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>Novaseq SE50/PE150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_8.png">
          <h4>项目周期</h4>
          <p>50个工作日</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>Q30＞80% , Q20＞85%</p>
        </li>
      </ul>
      <en-title title="技术路线" enTitle="Testing Workflow" />
      <div class="tc con"><img src="@/assets/images/whole_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/whole_1.png"> </div>
      <en-title title="研究内容" enTitle="Bioinformatics Service" />
      <service-table
        :tableColumn="tableColumn"
        :tableData="tableData"
        :headerCellStyle="headerCellStyle"
        :tableSpanMethod="tableSpanMethod"
      />
    </section>
    <new-consult
      title="样本制备与寄样"
      enTitle="Sample Requirement and Shipment"
      :samplingText="samplingText"
      :typeList="['sampling']"
    />
    <!-- <qk-consult type="Virus"/> -->
  </div>
</template>
<script>
import bread from "@/components/bread";
import ServiceTable from "./components/serviceTable";
import ApplicationIcon from "./components/applicationIcon";
export default {
  inject: ['reload'],
  components: {
    bread,
    ServiceTable,
    ApplicationIcon,
  },
  data () {
    return {
      samplingText: "擎科生物全转录组测序目前接收细胞、动物组织、植物组织、真菌菌体、细菌菌体、血液等组织样本与提取好的total RNA。",
      tableColumn: [
        {
          prop: "method1",
        },
        {
          label: "全转录组标准生信分析",
          prop: "method2",
          html: true,
        },
      ],
      tableData: [
        {
          method1: `1) LncRNA标准分析内容`,
          method2: `4) 联合分析内容
                    <p class="ml17 mt10">4.1 全局展示所有RNA的数目、表达量以及基于染色体的相对表达量</p>
                    <p class="ml17 mt10">4.2 差异RNA的数目、表达量的全局展示</p>
                    <p class="ml17 mt10">4.3 共表达分析（样品数目不少于5个）</p>
                    <p class="ml17 mt10">4.4 ceRNA网络分析</p>
                    <p class="ml17 mt10">4.5 关键基因通路整合分析</p>
                    <div class="ml17 mt10">4.6 差异RNA靶向关系联合分析
                      <p class="ml30 mt10">4.6.1 差异LncRNA相关靶向RNA分析</p>
                      <p class="ml30 mt10">4.6.2 差异circRNA的Host gene及相关靶向RNA分析</p>
                      <p class="ml30 mt10">4.6.3 差异miRNA相关靶向RNA分析</p>
                      <p class="ml30 mt10">4.6.4 差异gene相关靶向RNA分析</p>
                      <p class="ml30 mt10">4.6.5 基于ceRNA网络的差异LncRNA-miRNA-mRNA关系对分析</p>
                      <p class="ml30 mt10">4.6.6 基于ceRNA网络的差异circRNA-miRNA-mRNA关系对分析</p>
                    </div>`,
        },
        {
          method1: `2) Small RNA标准分析内容`,
        },
        {
          method1: `3) CircRNA标准分析内容`,
        },
        {
          method1: ``,
        },
        {
          method1: ``,
        },
      ],
      iconList: [
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_1',
          title:'生长发育机制研究',
        },
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_2',
          title:'复杂疾病研究',
        },
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_3',
          title:'癌症及分子标志物研究',
        },
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_4',
          title:'育种相关研究',
        },
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_5',
          title:'药物作用机制及\n靶点相关研究',
        },
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_6',
          title:'农业、畜牧业相关研究',
        },
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_7',
          title:'肿瘤早期诊断、预后\n以及治疗监测',
        },
        {
          img:'ngs_second/transcriptome/whole_transciptome/icon_8',
          title:'机体免疫应答机制研究',
        },
      ],
    }
  },
  created() {
    this.reload()
  },
  methods: {
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        row[1].colSpan = 2;
        if (columnIndex === 0) {
          return {
            display: "none",
          };
        }
      }
    },
    tableSpanMethod({ row, column, rowIndex, columnIndex }){
      if (columnIndex === 1) {
        return {
          rowspan: row.method2 ? 5 : 0,
          colspan: row.method2 ? 1 : 0
        }
      }
      if (rowIndex === 2) {
        return {
          rowspan: row.method1 ? 3 : 0,
          colspan: row.method1 ? 1 : 0
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/whole_transciptome.vue